import Updates from "../components/updates/Updates";

const HomePage = () => <Updates />;

export default HomePage;
